module.exports = __webpack_public_path__ + "gw.svg?6cff1be1e4c69c07d8cf16416e6ed22f";